import { Dialogs } from '@leverege/ui-elements';
import { Context, Config } from '@leverege/plugin';
import { DataSources, Attributes } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { AllowedReducer } from '@leverege/api-redux';
import ReplaceCustomerLocator from '../../views/billing/ReplaceCustomerLocator';
import RecovrSales from '../../util/RecovrSales';
export default {
  id: 'recovr.replaceLocator',
  name: 'Replace Customer Locator',
  layout: {
    sort: 'recovrSaleActions.replaceLocator',
    sectionName: 'RecovR Sale Actions'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: 'location.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'sale',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.locations.sales',
    objectType: 'sale'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  prepare: async cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0 || targets.length > 1 || targets[0]?.data?.data?.state !== 'sold' || targets[0]?.data?.data?.type !== 'vehicle-with-locator') {
      return false;
    }
    const parentPath = Config.get('VoidSale', 'saleLocationParentPath', 'location');
    const actions = DataSources.getDelegate(targets[0]);
    return RecovrSales.canReplaceLocator({
      saleId: targets[0].id,
      locationId: targets[0].data?.data?.[parentPath]?.id,
      actions
    });
  },
  isPrepared: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0 || targets.length > 1 || targets[0]?.data?.data?.state !== 'sold' || targets[0]?.data?.data?.type !== 'vehicle-with-locator') {
      return true;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    return a.replaceCustomerLocator != null;
  },
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0 || targets.length > 1) {
      return false;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);

    // if its vehicle-with-locator, but the recovr product is null-ish, coalesce to true because
    // its an old sale
    const locatorProduct = Attributes.get('sale.productTypes.recovr', targets[0].type, targets[0].data) ?? true;
    return a.replaceCustomerLocator === true && targets[0]?.data?.data?.state === 'sold' && targets[0]?.data?.data?.type === 'vehicle-with-locator' && locatorProduct;
  },
  appearance: () => {
    return {
      icon: Config.get('TransferLocator', 'icon', 'https://recovr-ui-assets.storage.googleapis.com/icon-transfer.png'),
      name: Config.get('TransferLocator', 'title', 'Replace Customer Locator')
    };
  },
  perform: async props => {
    const {
      context
    } = props;
    const {
      clientProps
    } = context;
    const sale = Context.getTargetsOfType(context, 'sale')[0];
    const actions = DataSources.getDelegate(sale);
    if (!sale) {
      return;
    }
    let locationActions = actions.parent().parent();
    let location;
    if (locationActions) {
      // Does not need to be awaited or asynchronously handled. Data is already present in redux
      location = locationActions?.getItem();
    } else {
      const locationId = Attributes.get('sale.location', 'sale', sale.data);
      location = {
        id: locationId,
        type: 'location',
        ref: actions.getInterfaceUrl().replace(/sales?\/.+/g, 'location')
      };
      location.data = DataSources.getData(location);
      locationActions = DataSources.getDelegate(location);
    }
    Dialogs.show({
      component: ReplaceCustomerLocator,
      props: {
        ...clientProps,
        sale,
        location,
        locationActions,
        icon: Config.get('TransferLocator', 'headerIcon', 'https://recovr-ui-assets.storage.googleapis.com/icon-replace-header.png'),
        title: Config.get('TransferLocator', 'title', 'Replace Customer Locator')
      }
    });
  }
};